import { render, staticRenderFns } from "./doQuiz.vue?vue&type=template&id=821b7b48&"
import script from "./doQuiz.vue?vue&type=script&lang=js&"
export * from "./doQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports